import _objectSpread from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RuleItem from '@/components/UserRule/ruleItem';
export default {
  name: 'editRule',
  components: {
    RuleItem: RuleItem
  },
  data: function data() {
    return {
      formInline: {
        ruleName: '',
        systemId: '',
        systemName: '',
        description: '',
        ruleStatus: 'ACTIVE',
        ruleId: null
      },
      jobList: [],
      checked: true,
      ruleList: [],
      systemList: [],
      formRules: {
        ruleName: [{
          required: true,
          message: '名称为必填选项',
          trigger: 'blur'
        }],
        systemId: [{
          required: true,
          message: '规则服务模块为必填选项',
          trigger: 'change'
        }],
        ruleStatus: [{
          required: true,
          message: '状态为必填选项',
          trigger: 'change'
        }],
        description: [{
          required: true,
          message: '筛选规则描叙为必填选项',
          trigger: 'blur'
        }]
      },
      edit: false,
      ruleInfo: null,
      isEdit: false,
      delRule: false,
      isAdd: false // 是否是新增状态
    };
  },

  methods: {
    editChoose: function editChoose() {
      this.isEdit = true;
    },
    delRuleItem: function delRuleItem(index) {
      this.ruleList.splice(index, 1);
    },
    reBack: function reBack() {
      this.$router.push({
        path: '/system/userRule'
      });
    },
    confirmdel: function confirmdel() {
      var _this = this;
      var ruleIdList = [];
      ruleIdList.push(this.formInline.ruleId);
      this.$API.delRequest({
        url: '/platform/userRule/ruleId',
        data: {
          ruleIdList: ruleIdList
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this.$message({
            message: '规则删除成功！',
            type: 'success'
          });
          _this.$router.push({
            path: '/system/userRule'
          });
        }
      });
    },
    preview: function preview() {
      this.$store.dispatch('system/setRuleInfo', _objectSpread(_objectSpread({}, this.formInline), {}, {
        userLabelSubRuleList: this.ruleList
      }));
      this.$router.push({
        name: 'preViewRule',
        params: {
          isEdit: this.isEdit ? 1 : 0,
          isAdd: this.isAdd,
          ruleName: this.formInline.ruleName
        }
      });
    },
    submit: function submit() {
      var _this2 = this;
      var emptyFlag = false;
      this.ruleList.forEach(function (ele) {
        if (ele.jobSelected || ele.businessLineSelected || ele.orgSelected) {
          if (ele.jobSelected && ele.userLabelConditionJob.itemIdList.length === 0) {
            emptyFlag = true;
            _this2.$set(ele.userLabelConditionJob, 'errMsg', '请完善信息填写！');
          } else if (ele.businessLineSelected && ele.userLabelConditionBusiness.itemIdList.length === 0) {
            emptyFlag = true;
            _this2.$set(ele.userLabelConditionBusiness, 'errMsg', '请完善信息填写！');
          } else if (ele.orgSelected && ele.userLabelConditionOrg.itemIdList.length === 0) {
            emptyFlag = true;
            _this2.$set(ele.userLabelConditionOrg, 'errMsg', '请完善信息填写！');
          }
        }
      });
      if (emptyFlag) {
        this.$message({
          type: 'warning',
          message: '请完善规则信息的填写。'
        });
        return;
      }
      this.$refs.formSubmit.validate(function (valid) {
        if (!valid) {
          _this2.$message({
            message: '请完善信息填写！',
            type: 'warning'
          });
        } else {
          _this2.$API.postRequest({
            url: '/platform/userRule/rule',
            data: _objectSpread(_objectSpread({}, _this2.formInline), {}, {
              userLabelSubRuleList: _this2.ruleList
            })
          }).then(function (res) {
            if (res.code === '0000000000') {
              _this2.$message({
                message: _this2.isAdd ? '新增成功' : '修改成功',
                type: 'success'
              });
              _this2.$router.push({
                path: '/system/userRule'
              });
            }
          });
        }
      });
    },
    addRule: function addRule() {
      this.ruleList.push({
        jobSelected: false,
        businessLineSelected: false,
        orgSelected: false,
        ruleOrder: this.ruleList.length + 1,
        userLabelConditionJob: {
          itemIdList: [],
          operator: 'INCLUDE',
          target: 'JOB_CODE'
        },
        userLabelConditionOrg: {
          itemIdList: [],
          operator: 'INCLUDE',
          target: 'ORG_ID'
        },
        userLabelConditionBusiness: {
          itemIdList: [],
          operator: 'INCLUDE',
          target: 'BUSINESS_LINE'
        }
      });
    },
    delSelect: function delSelect() {},
    init: function init() {
      var _this3 = this;
      this.$API.getRequest({
        url: '/platform/job/allJob'
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this3.jobList = res.result;
        }
      });
      this.$API.getRequest({
        url: '/platform/systemInner/list'
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this3.systemList = res.result.records;
          _this3.formInline.systemId = _this3.ruleInfo.systemId;
        }
      });
    }
  },
  created: function created() {
    // eslint-disable-next-line eqeqeq
    if (this.$route.query.isEdit == '1') {
      this.isEdit = true;
    } else {
      this.isEdit = false;
    }
    // eslint-disable-next-line eqeqeq
    if (this.$route.query.isAdd == '1') {
      this.isAdd = true;
    } else {
      this.isAdd = false;
    }
    this.ruleInfo = this.$store.state.system.ruleInfo || null;
    if (!this.ruleInfo) {/* empty */} else {
      this.formInline.description = this.ruleInfo.description;
      this.formInline.ruleName = this.ruleInfo.ruleName;
      this.formInline.ruleStatus = this.ruleInfo.ruleStatus;
      this.formInline.systemName = this.ruleInfo.systemName;
      this.formInline.ruleId = this.ruleInfo.ruleId;
      this.ruleList = this.ruleInfo.userLabelSubRuleList;
      this.delRule = this.ruleInfo.delRule;
    }
    this.init();
  },
  // activated(){
  //   console.log('调用缓存组件陈宫')
  // },
  computed: {},
  beforeRouteLeave: function beforeRouteLeave(to, form, next) {
    if (to.name !== 'preViewRule') {
      this.$route.meta.keepAlive = false;
    } else {
      this.$route.meta.keepAlive = true;
    }
    next();
  }
};